export const environment = {
  production: false,
  apiUrl: 'https://mo40e4lukf.execute-api.us-west-2.amazonaws.com/QA',
  apiNodeUrl: 'https://d81skr9y46.execute-api.us-west-2.amazonaws.com/QA/api',
  s3BINRules: 'https://pfmverify-bin-rules.s3.us-west-2.amazonaws.com/bin-rules-qa.json',
  maxSessionIdleTimeMinutes: 10,
  maxRegisterSessionTimeMinutes: 1440,
  internalRestartAffiliateId: 586,
  CipherPassphrase: '36ebe205bcdfc499a25e6923f4450fa8',
  GoogleMapsAPI: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB0Nrp5Jb-3SM1SzTK_bvY60WUfPoQF7ls&libraries=places&language=en',
  MaxAttemptsCreditCard: 4,
  MaxAttemptsPerCreditCard: 2,
  MaxAttemptsForMXVerification: 2,
  MaxAttemptsForDirectPayment: 2,
  FunnelsDomains: [],
  MemberPortalDomains: [],
  GoogleAdsConversionId: "AW-16898516247/CKCQCImCxrYaEJfK6_k-",
  UrlRewardProgramGetToken: "https://dev.mysavingsperks.com/login/login_by_stream/",
  BoardwalkIntegration: "https://api.boardwalk.marketing/promenade/loader/?pid={pid}&role={role}",
  BoardwalkIntegrationV2: "https://next.boardwalk.marketing/api/paths/{token}/serve",
  BoardwalkDeclineToken: "3syicLn4HQObXpL1EwHaxEGrmh8UEPu-",
  BoardwalkDuplicateUserToken: "ef_k6Ei8DipoHXX7kLMGLiJkFLkUqeR6",
  BoardwalkThankYouToken: "JvMw1bdyIowMdGCe5WCUUl3R71_w91ZZ",
  MarketingDomains: ["https://path.pfiverify.com", "https://path.financeify.co", "https://home.pfiverify.com", "https://home.financeify.co", "https://loans.pfiverify.com", "https://loans.financeify.co", "https://ecommerce.pfiverify.com", "https://ecommerce.financeify.co", "https://financial.pfiverify.com", "https://financial.financeify.co", "https://credit.pfiverify.com", "https://credit.financeify.co", "https://auto.pfiverify.com", "https://auto.financeify.co", "https://insurance.pfiverify.com", "https://insurance.financeify.co", "https://offers.pfiverify.com", "https://thankyou.pfiverify.com", "https://offers.financeify.co", "https://thankyou.financeify.co"],
  UrlBucketDynamicCSSBoardwalk: "https://dynamic-css-boardwalk-page-us-credique.s3.us-west-2.amazonaws.com/dynamic-css-boardwalk-page-us-credique-{PageType}.css",
  assetsURL: 'https://credique-us-assets.s3.us-west-2.amazonaws.com/',
  HorizonIntegrationUrl: 'https://get.brightoffers.io/js/get.js',
  HorizonIntegrationId: '96ce6031f17d-1235-1f8d-4172-45e3-8a5ffc9f',
  HorizonIntegrationAfId: '581',
  RecaptchaV3KeySite: "6LdLxeUrAAAAAFubfJipz0JBjKVEk0Y7sbMPbjAQ",
  SplashPageDomains: ["https://stage.loanconfirm.com"],
  ThreeDSUrl: "/lib/threeds.2.min.latest.js",
  exitPopUp: {
    ctaBaseUrl: 'https://zipyclick.com/',
    affiliate: 'CR_Exit1'
  },
  MXConnectScriptUrl: "https://atrium.mx.com/connect.js",
  GoCardlessDropinScriptUrl: "https://pay.gocardless.com/billing/static/dropin/v2/initialise.js",
};
